export type Section = 'personality' | 'interests' | 'values';

type ProgressRecord = {
  currentIndex: number;
  answers: Record<string, boolean | null>;
};

const progressKey = (companyId: string | undefined, section: Section) => `tf:progress:${companyId || 'unknown'}:${section}`;

const lastSectionKey = (companyId: string | undefined) => `tf:last-section:${companyId || 'unknown'}`;

function safeParse<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function getProgress(companyId: string | undefined, section: Section): ProgressRecord {
  const raw = localStorage.getItem(progressKey(companyId, section));
  const parsed = safeParse<ProgressRecord>(raw);
  if (parsed && typeof parsed.currentIndex === 'number' && parsed.answers) {
    return parsed;
  }
  return { currentIndex: 0, answers: {} };
}

export function setProgress(companyId: string | undefined, section: Section, progress: ProgressRecord): void {
  localStorage.setItem(progressKey(companyId, section), JSON.stringify(progress));
  // update last section + index for quick resume
  setLeftOff(companyId, section, progress.currentIndex);
}

export function clearProgress(companyId: string | undefined, section: Section): void {
  localStorage.removeItem(progressKey(companyId, section));
}

export function getLeftOff(companyId: string | undefined): { section: Section; index: number } | null {
  const raw = localStorage.getItem(lastSectionKey(companyId));
  const parsed = safeParse<{ section: Section; index: number }>(raw);
  if (parsed && parsed.section && typeof parsed.index === 'number') return parsed;
  return null;
}
export function setLeftOff(companyId: string | undefined, section: Section, index: number): void {
  localStorage.setItem(lastSectionKey(companyId), JSON.stringify({ section, index }));
}
